import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=3389efe0&scoped=true"
import script from "./AppList.vue?vue&type=script&lang=js"
export * from "./AppList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389efe0",
  null
  
)

export default component.exports